import script from "./CancelAppointmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelAppointmentDialog.vue?vue&type=script&setup=true&lang=js"

import "./CancelAppointmentDialog.vue?vue&type=style&index=0&id=436509ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436509ea"]])

export default __exports__